import { render } from "./FilesView.vue?vue&type=template&id=4ea97ada"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4ea97ada"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ea97ada', script)) {
    api.reload('4ea97ada', script)
  }
  
  module.hot.accept("./FilesView.vue?vue&type=template&id=4ea97ada", () => {
    api.rerender('4ea97ada', render)
  })

}

script.__file = "src/views/files/FilesView.vue"

export default script